import type { KpiCardSpec } from '../kpis/card-spec';
import { ACTIVE_USERS_SCALAR_CARD } from '../kpis/active-users-scalar-card';
import { WEEKLY_ACTIVE_USERS_SCALAR_CARD } from '../kpis/weekly-active-users-scalar-card';
import { DAILY_ACTIVE_USERS_SCALAR_CARD } from '../kpis/daily-active-users-scalar-card';
import { AVG_ACTIVE_DAYS_PER_USER_SCALAR_CARD } from '../kpis/avg-active-days-per-user-scalar-card';
import { withDashboardLookAll } from '../kpis/with-dashboard-look';

/**
 * Engagement breakdown: the three active-user windows, widest first, then the
 * share of those visits that are a return.
 */
export const ENGAGEMENT_BREAKDOWN_CARDS: KpiCardSpec[] = withDashboardLookAll(
    [
        ACTIVE_USERS_SCALAR_CARD,
        WEEKLY_ACTIVE_USERS_SCALAR_CARD,
        DAILY_ACTIVE_USERS_SCALAR_CARD,
        {
            title: 'Repeat visit rate',
            source: 'engagement',
            metric: 'repeatVisitRate',
            form: 'rate',
            size: 'sm',
            description:
                "Share of visits in the selected period that are repeat visits rather than a user's first, from GA4 engagement data. Region resolves from the device's GA4 geo-IP, not the account's province, so a provincial reading will not match an account-based cohort exactly.",
        },
    ],
    'pink'
);

/**
 * `sessionsPerUser` and `avgSessionLengthSeconds` are averages, so `number`,
 * which renders a ratio's `rate` as a plain number instead of a percent.
 * `featureActiveUsers` is a share, so `rate`.
 */
export const USAGE_ADOPTION_CARDS: KpiCardSpec[] = withDashboardLookAll(
    [
        {
            title: 'Sessions per user',
            source: 'engagement',
            metric: 'sessionsPerUser',
            form: 'number',
            size: 'sm',
            description:
                "Average number of sessions per user in the selected period, from GA4 engagement data. Region resolves from the device's GA4 geo-IP, not the account's province, so a provincial reading will not match an account-based cohort exactly.",
        },
        {
            title: 'Avg session length',
            source: 'engagement',
            metric: 'avgSessionLengthSeconds',
            form: 'number',
            size: 'sm',
            description:
                "Average time spent per session in the selected period, from GA4 engagement data. Region resolves from the device's GA4 geo-IP, not the account's province, so a provincial reading will not match an account-based cohort exactly.",
        },
        {
            title: 'Feature adoption',
            source: 'feature-active-users',
            metric: 'featureActiveUsers',
            form: 'rate',
            size: 'sm',
            description:
                'Of the users who signed up in the selected period, the share who have ever activated a promotion or used the carwash. The activation itself is not bounded by the period.',
        },
        AVG_ACTIVE_DAYS_PER_USER_SCALAR_CARD,
        {
            // Last point is the Daily active users tile in the section above, on
            // the same metric.
            title: 'Daily active users trend',
            source: 'login-activity',
            metric: 'dailyActiveUsers',
            form: 'line',
            size: 'lg',
            description:
                'One point per day in the selected period, each counting the distinct users who signed in that day. Deliberate logins only: a token refresh is not a login. Someone who signs in on more than one of those days is counted again each time, so adding up the points overstates how many people were active across the whole period.',
        },
    ],
    'pink'
);
